import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4114a67d"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=4114a67d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/vercel/path0/components/navbar.vue').default,ChefLoading: require('/vercel/path0/components/chef/loading.vue').default,UiLink: require('/vercel/path0/components/ui/link.vue').default,UiRating: require('/vercel/path0/components/ui/rating.vue').default,UiIconChefHat: require('/vercel/path0/components/ui/icon/chef-hat.vue').default,ChefImageCard: require('/vercel/path0/components/chef/image-card.vue').default,ChefFilter: require('/vercel/path0/components/chef/filter.vue').default,UiReadMore: require('/vercel/path0/components/ui/read-more.vue').default,UiIconLogo: require('/vercel/path0/components/ui/icon/logo.vue').default,ChefReview: require('/vercel/path0/components/chef/review.vue').default,ChefDetailCard: require('/vercel/path0/components/chef/detail-card.vue').default,UiContactCard: require('/vercel/path0/components/ui/contact-card.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
